/**
 * Grey Muzzle Theme — theme.js
 * Vanilla JS, no dependencies. Mobile-first, accessible.
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initStickyHeader();
    initFadeIn();
    initProductGallery();
    initQuantityControls();
    initVariantSelector();
  });

  /* -------------------------------------------------------
     Mobile Navigation Drawer
  ------------------------------------------------------- */
  function initMobileNav() {
    var hamburger = document.querySelector('.header-hamburger');
    var drawer    = document.querySelector('.mobile-nav');
    var overlay   = document.querySelector('.mobile-nav-overlay');

    if (!hamburger || !drawer) return;

    function openNav() {
      drawer.classList.add('is-open');
      overlay && overlay.classList.add('is-visible');
      hamburger.classList.add('is-active');
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function closeNav() {
      drawer.classList.remove('is-open');
      overlay && overlay.classList.remove('is-visible');
      hamburger.classList.remove('is-active');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger.focus();
    }

    hamburger.addEventListener('click', function () {
      drawer.classList.contains('is-open') ? closeNav() : openNav();
    });

    overlay && overlay.addEventListener('click', closeNav);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeNav();
    });
  }

  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    function onScroll() { header.classList.toggle('is-scrolled', window.scrollY > 8); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initFadeIn() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.fade-in, .fade-in-stagger').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var opts = { threshold: 0.08, rootMargin: '0px 0px -40px 0px' };
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, opts);
    document.querySelectorAll('.fade-in, .fade-in-stagger').forEach(function (el) { observer.observe(el); });
  }

  function initProductGallery() {
    var mainImg    = document.querySelector('#product-main-img');
    var thumbnails = document.querySelectorAll('.product-thumbnail');
    if (!mainImg || !thumbnails.length) return;
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); thumb.click(); } });
      thumb.addEventListener('click', function () {
        var newSrc = this.dataset.src;
        if (!newSrc) return;
        mainImg.style.opacity = '0.4';
        setTimeout(function () { mainImg.src = newSrc; mainImg.style.opacity = ''; }, 120);
        thumbnails.forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      });
    });
  }

  function initQuantityControls() {
    document.querySelectorAll('.product-quantity').forEach(function (wrapper) {
      var input = wrapper.querySelector('.quantity-input');
      var minus = wrapper.querySelector('[data-action="minus"]');
      var plus  = wrapper.querySelector('[data-action="plus"]');
      if (!input) return;
      function clamp(val) {
        var min = parseInt(input.min || '1', 10);
        var max = parseInt(input.max || '9999', 10);
        return Math.min(max, Math.max(min, val));
      }
      minus && minus.addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) - 1); });
      plus  && plus.addEventListener('click',  function () { input.value = clamp(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function () { input.value = clamp(parseInt(input.value, 10) || 1); });
    });
  }

  function initVariantSelector() {
    var selector     = document.querySelector('.variant-select');
    var variantsData = document.getElementById('product-variants-json');
    if (!selector || !variantsData) return;
    var variants;
    try { variants = JSON.parse(variantsData.textContent); } catch (_) { return; }
    var priceEl        = document.getElementById('product-price');
    var comparePriceEl = document.getElementById('product-compare-price');
    var atcBtn         = document.querySelector('.product-atc-btn');
    var variantInput   = document.querySelector('input[name="id"]');
    function formatMoney(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    selector.addEventListener('change', function () {
      var id = parseInt(this.value, 10);
      var v  = variants.find(function (vv) { return vv.id === id; });
      if (!v) return;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (comparePriceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { comparePriceEl.textContent = formatMoney(v.compare_at_price); comparePriceEl.hidden = false; }
        else { comparePriceEl.hidden = true; }
      }
      if (atcBtn) { atcBtn.disabled = !v.available; atcBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
      if (variantInput) variantInput.value = id;
    });
  }

})();
